export const INVOICE_STATUS_FAILED = "FAILED";
export const INVOICE_STATUS_PROCESSING = "PROCESSING";
export const INVOICE_STATUS_PROCESSING_FAILED = "PROCESSING_FAILED";
export const INVOICE_STATUS_SUCCESS = "SUCCESS";

export const INVOICE_STATUSES = {
  [INVOICE_STATUS_FAILED]: {
    desc: "Failed to create e-Invoice",
    color: "red",
  },
  [INVOICE_STATUS_PROCESSING]: {
    desc: "e-Invoice created and under processing",
    color: "blue",
  },
  [INVOICE_STATUS_PROCESSING_FAILED]: {
    desc: "Invcoie processing failed",
    color: "red",
  },
  [INVOICE_STATUS_SUCCESS]: {
    desc: "Invoice successfully created and processed",
    color: "green",
  },
};
